import type { MemberRow } from 'src/components/star-grid/utils/subset-editor/memberSubset';

export const reconcileMemberSelection = (
  checked: ReadonlySet<string>,
  visibleRows: readonly MemberRow[],
  allRows: readonly MemberRow[],
  selected: readonly string[],
  replace: boolean
): string[] => {
  const visible = new Set(visibleRows.map((row) => row.key));
  const retained = replace ? [] : [...checked].filter((key) => !visible.has(key));
  const next = new Set([...retained, ...selected]);
  // A filtered tree can mark a parent selected with only some of its actual children checked.
  for (const row of [...allRows].reverse()) {
    const parent = row.displayPath[row.displayPath.length - 2];
    if (parent && !next.has(row.key)) next.delete(parent);
  }
  return [...next];
};
